<template>
  <div
    class="style1-wap"
    :class="{
      must: fieldObj.required == 1,
      err: fieldObj.dirty && fieldObj.invalid
    }"
  >
    <div class="u-reg-desc" v-html="descHtmlContent"></div>
  </div>
</template>
<script>
import descMixin from "../../field/new-fields/desc";
export default {
  name: "sk-desc-wap",
  mixins: [descMixin]
};
</script>
<style lang=""></style>
